import { store } from "../store";
import { encode } from "querystring";
import { api } from "./rtkApi";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAuthKey: build.query({
      query: ({ inreesId, inreesToken, affiliation, tracking, ts }) => {
        return {
          method: "POST",
          url: `/user/cle?ts=${ts}`,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: encode({
            idinexplore: inreesId,
            token: inreesToken,
            affiliation,
            tracking,
          }),
        };
      },
    }),
    getUser: build.query({
      query: ({ts}) => {
        const state = store.getState();
        let authToken = state.auth.authToken;
        let idinexplore = state.auth.inreesId;
        return {
          method: "GET",
          url: `/user/infos?ts=${ts}`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
      },
    }),
    getProInformation: build.query({
      query: ({ authToken }) => {
        return {
          method: "GET",
          url: `/user/infos-pro`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
      },
    }),
    setInfosPro: build.mutation({
      query: ({ authToken, jsonPratiques }) => {
        return {
          method: "POST",
          url: `/user/set-infos-pro`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
          body: {
            jsonPratiques: JSON.stringify(jsonPratiques),
          },
        };
      },
    }),
    setWhenBegin: build.mutation({
      query: ({ authToken, whenBegin }) => {
        return {
          method: "PATCH",
          url: `/user/set-whenBegin`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
          body: {
            whenBegin: whenBegin.toString()
          },
        };
      },
    }),
    setWebsite: build.mutation({
      query: ({ authToken, website }) => {
        return {
          method: "PATCH",
          url: `/user/set-website`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
          body: {
            website,
          },
        };
      },
    }),
    setCertificate: build.mutation({
      query: ({ authToken, certificate }) => {
        return {
          method: "PATCH",
          url: `/user/set-certificate`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
          body: {
            certificate,
          },
        };
      },
    }),
    searchPratices: build.query({
      query: ({ query, authToken }) => {
        return {
          method: "GET",
          url: `/user/search-pratiques?word=${query}`,
          headers: {
            authorization: "Bearer " + authToken,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAuthKeyQuery,
  useLazyGetAuthKeyQuery,

  useGetUserQuery,
  useLazyGetUserQuery,

  useGetProInformationQuery,
  useLazyGetProInformationQuery,

  useSetInfosProMutation,
  useSetWebsiteMutation,
  useSetWhenBeginMutation,
  useSetCertificateMutation,

  useSearchPraticesQuery,
  useLazySearchPraticesQuery,
} = userApi;
